import { fetchManifest } from '@/lib/request/fetchManifest';
import { useUserStore } from '@/stores/user';

export function startCodeVersionAutoUpdateCheck(minutes: number) {
  const user = useUserStore();
  setInterval(async () => {
    if (user.isUserActive()) {
      return;
    }
    if (!user.isUserActive() && !isLatestCodeVersion()) {
      window.location.reload();
    }
  }, minutes * 60000);
}

export async function isLatestCodeVersion() {
  const latestFile = await fetchManifest();
  const currentFile = document?.querySelector<HTMLScriptElement>(
    'script[type="module"]'
  )?.src;

  return currentFile?.endsWith(latestFile);
}
export function scheduleNightlyReload(reloadTimeHour: number) {
  const timeUntilReload = timeUntilNightlySync(reloadTimeHour);
  setTimeout(() => {
    runNightlyReload();
  }, timeUntilReload);
}

function runNightlyReload() {
  const user = useUserStore();
  if (user.isUserActive()) {
    setTimeout(() => {
      runNightlyReload();
    }, 5 * 60000);
    return;
  }

  window.location.reload();
}

export function timeUntilNightlySync(reloadTimeHour: number) {
  const resetTime = new Date();
  resetTime.setHours(reloadTimeHour);
  resetTime.setMinutes(0);
  resetTime.setSeconds(0);
  resetTime.setMilliseconds(0);

  const timeUntilReset = resetTime.getTime() - new Date().getTime();
  if (timeUntilReset > 0) {
    return timeUntilReset;
  } else {
    const tomorrowResetTime = new Date();
    tomorrowResetTime.setDate(resetTime.getDate() + 1);
    tomorrowResetTime.setHours(4);
    tomorrowResetTime.setMinutes(0);
    tomorrowResetTime.setSeconds(0);
    tomorrowResetTime.setMilliseconds(0);
    return tomorrowResetTime.getTime() - new Date().getTime();
  }
}
